import { useMutation } from "react-query";
import http from "infra/http";

function useDeleteArquivo() {
  return useMutation(
    (id: string) => {
      return http.delete(`/v1/documento/${id}`);
    },
    {
      retry: false,
    }
  );
}

export default useDeleteArquivo;
